import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f2195a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-bottom-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dummy-background" }, null, -1))
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  class: "modal-options",
  ref: "modalOption"
}
const _hoisted_9 = { class: "modal-list" }
const _hoisted_10 = { class: "modal-list-item" }
const _hoisted_11 = {
  key: 1,
  class: "modal-list-item__separator"
}
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = ["onClick", "disabled"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "btn-content-text" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "btn-content-text"
}

export function render(_ctx, _cache) {
  const _component_q_checkbox = _resolveComponent("q-checkbox")
  const _component_q_input = _resolveComponent("q-input")
  const _component_LoadingButton = _resolveComponent("LoadingButton")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass([['modal-bottom', _ctx.modalOptions.classNameHeader], {show: _ctx.active}])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.modalOptions.title), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(_ctx.modalOptions.body), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_ctx.reasonList.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.reasonList, (list, index) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_q_checkbox, {
                        size: "20px",
                        modelValue: _ctx.selectedReasonList,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedReasonList) = $event)),
                        label: list['text_th'],
                        val: list,
                        onClick: $event => (_ctx.handleToggleCheckbox(list)),
                        disable: _ctx.isInProgress
                      }, null, 8, ["modelValue", "label", "val", "onClick", "disable"]),
                      (list['is_required_other_text'] && _ctx.selectedReasonList.find((data)=> data['group_code'] === list['group_code'] && data['reason_code'] === list['reason_code']))
                        ? (_openBlock(), _createBlock(_component_q_input, {
                            key: 0,
                            outlined: "",
                            modelValue: _ctx.otherTextMap[`${list['group_code']}-${list['reason_code']}`],
                            "onUpdate:modelValue": [$event => ((_ctx.otherTextMap[`${list['group_code']}-${list['reason_code']}`]) = $event), $event => (_ctx.handleUpdateInput(list))],
                            label: "ระบุเหตุผล",
                            hint: "ความยาวตัวอักษร",
                            "no-error-icon": "",
                            counter: "",
                            clearable: "",
                            maxlength: "200",
                            rules: [val => (val && val.length) || 'โปรดระบุเหตุผล'],
                            ref_for: true,
                            ref: `otherTextInput-${list['group_code']}-${list['reason_code']}`,
                            disable: _ctx.isInProgress
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "rules", "disable"]))
                        : _createCommentVNode("", true),
                      (index !== _ctx.reasonList.length - 1)
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_11))
                        : _createCommentVNode("", true)
                    ]))
                  }), 256))
                : _createCommentVNode("", true)
            ])
          ], 512),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalOptions.actionOptions, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                class: "btn",
                style: _normalizeStyle({color: item.color ? item.color : '#424242', 
						backgroundColor: item.backgroundColor ? (_ctx.isInProgress ? item.inProgressColor : item.backgroundColor) : '#E8E8E8', 
						borderColor: item.backgroundColor ? (_ctx.isInProgress ? item.inProgressColor : item.backgroundColor) : '#E8E8E8'}),
                onClick: $event => (item?.action ? _ctx.handleSubmitModal(item?.action) : _ctx.closeModal()),
                disabled: _ctx.isInProgress || (item.validate && _ctx.isFormDisabled())
              }, [
                (!item.action)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(item.text ? item.text : 'Close'), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.action)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (!_ctx.isInProgress)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.text ? item.text : 'Close'), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isInProgress)
                        ? (_openBlock(), _createBlock(_component_LoadingButton, { key: 1 }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 12, _hoisted_13))
            }), 256))
          ])
        ])
      ])
    ], 2)
  ]))
}